import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import HeroSlider from "../components/Home/HeroSlider";
import DeliveryInfo from "../components/Home/DeliveryInfo";
import ClearanceSection from "../components/Home/ClearanceSection";
import TrendingProducts from "../components/Home/TrendingProducts";
import ItalianSection from "../components/Home/ItalianSection";
import BestSeller from "../components/Home/BestSeller";
import WineClub from "../components/Home/WineClub";
import BrandSlider from "../components/Home/BrandSlider";
import HomeCategory from "../components/Home/HomeCategory";
import Hero from "../components/Home/Hero";
import PromoBanner from "../components/PromoBanner";

const Home = () => {
  const [addedItems, setAddedItems] = useState([]);
  const [product, setProduct] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}productlist`
        );
        const data = await response.json();
        setProduct(data.products || []);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}categories`
      );
      const data = await response.json();
      setCategories(data);
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    setAddedItems(cart.map((item) => item.id));
  }, []);

  const addToCart = (item) => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    window.dispatchEvent(new Event("cartUpdated"));

    if (!cart.some((cartItem) => cartItem.id === item.id)) {
      cart.push(item);
      localStorage.setItem("cart", JSON.stringify(cart));
      setAddedItems([...addedItems, item.id]);
    }
  };

  return (
    <>
      {/* <HeroSlider /> */}
      <Hero />
      <HomeCategory />
      {/* <DeliveryInfo /> */}
      {/* <ClearanceSection /> */}
      <TrendingProducts
        products={product}
        categories={categories}
        addToCart={addToCart}
        addedItems={addedItems}
      />
      <PromoBanner />
      {/* <ItalianSection /> */}
      <BestSeller
        products={product}
        addToCart={addToCart}
        categories={categories}
        addedItems={addedItems}
      />
      {/* <WineClub /> */}
      {/* <BrandSlider /> */}
      <DeliveryInfo />
    </>
  );
};

export default Home;
